module.exports = __webpack_public_path__ + "static/media/Jigoro Kano.eb003d07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/Jigoro Kano.jpg
// module id = 84
// module chunks = 0